import React, {createContext, useState} from 'react';
import AffiliateService from "../services/AffiliateService";
import confirmationModal from "../components/common/ConfirmationModal";
import Notification from "../components/common/Notification";

export const AffiliateContext = createContext("AffiliateContext");

const AffiliateContextProvider = ({children}) => {

    const [affiliates, setAffiliates] = useState([]);
    const [affiliate, setAffiliate] = useState(null);
    const [pharmacySubscriptionPlan, setAffiliateSubscriptionPlan] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState(0);
    const [initProductLoading, setInitProductLoading] = useState(false);
    const [initAffiliateFileLoading, setInitAffiliateFileLoading] = useState(false);

    const [commissionList, setCommissionList] = useState([]);

    const [transactionLoading, setTransactionLoading] = useState(false);


    async function getAllAffiliate(params) {
        // async function getAllAffiliate({page, size, id, name, pharmacyOwnerName, pharmacyOwnerPhone}) {

        try {
            setLoading(true);
            const res = await AffiliateService.getAllAffiliate(params);
            // const res = await AffiliateService.getAllAffiliate(page, size, id, name, pharmacyOwnerName, pharmacyOwnerPhone);
            setAffiliates(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            console.log("error", console.error())
            return false;
        }

    }

    async function getAllCommission(params) {

        try {
            setLoading(true);
            const res = await AffiliateService.getAllCommission(params);
            setCommissionList(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            console.log("error", console.error())
            return false;
        }

    }

    async function getAffiliateById(id) {

        try {
            setLoading(true);
            setErrorMsg('');
            const res = await AffiliateService.getAffiliateById(id);
            setAffiliate(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Affiliates. Please check the console.");
            console.log("error", error)
            return false;
        }

    }

    async function getSubscriptionPlanForAffiliate() {

        try {
            setLoading(true);

            setErrorMsg('');
            const res = await AffiliateService.getSubscriptionPlanForAffiliate();
            setAffiliateSubscriptionPlan(res.data);
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Affiliates. Please check the console.");
            console.log("error", error)
            return false;
        }

    }

    async function addAffiliate(data, pharmacyOwnerId) {

        try {
            setLoading(true);
            setErrorMsg("")
            const res = await AffiliateService.addAffiliate(data, pharmacyOwnerId)
            setAffiliate(res.data);
            setLoading(false)
            return true;
        } catch (err) {
            setLoading(false);
            const message = err.response ? err.response.data.message : err.message;
            console.log("post affiliate error", message);
            confirmationModal(message, "error");
            return false;
        }
    }

    async function updateAffiliate(data, id) {
        try {
            setLoading(true);
            await AffiliateService.updateAffiliate(data, id)
            setLoading(false);
            // confirmationModal("affiliate updated properly. ", "success");
            Notification("success", "Updated", `affiliate updated properly`);
            return true;
        } catch (error) {
            setLoading(false);
            const message = error.response ? error.response.data.message : error.message
            confirmationModal("Can not update affiliate." + message, "error");
            return false;
        }

    }

    // async function deleteAffiliate(id) {
    //
    //     try {
    //         setLoading(true);
    //         await AffiliateService.deleteAffiliate(id);
    //         let updatedAffiliate = affiliates;
    //         updatedAffiliate = affiliates.filter(e => e.id !== id)
    //         setAffiliates(updatedAffiliate);
    //         setLoading(false);
    //         return true;
    //     } catch {
    //         setLoading(false);
    //         return false;
    //     }
    //
    // }

    const disableOrEnableAffiliate = async (disable, id) => {


        try {
            setLoading(true);
            await AffiliateService.disableOrEnableAffiliate(disable, id);
            let updatedAffiliate = affiliates;
            // updatedAffiliate = affiliates.map(e => {
            //     if (e.email === disable) e.status = status;
            //     return e;
            // })

            Notification("success", "Updated", "Affiliate updated successfully.");


            setAffiliates(affiliates?.map(e => {
                if (e.id === id) {
                    e.disabled = disable;
                }
                return e;
            }))
            setAffiliates(updatedAffiliate);
            setLoading(false);
            return true;
        } catch {
            setLoading(false);
            return false;
        }

    }

    const changeAffiliatePasswordById = async (data, id) => {
        try {
            await AffiliateService.changeAffiliateUserPasswordById(data, id);
            Notification("success", "Password Changed", "Password changed successfully");
            return true;
        } catch (error) {
            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    const generateAffiliateExcelReport = async (params) => {
        try {
            setTransactionLoading(true);
            setErrorMsg("");
            const res = await AffiliateService.getAffiliateReport(params);
            // if (res) {
            //     const url = window.URL.createObjectURL(new Blob([res.data]));
            //     const link = document.createElement("a");
            //     link.href = url;
            //     link.setAttribute("download", res.headers["content-disposition"].split("filename=")[1]);
            //     document.body.appendChild(link);
            //     link.click();
            // }

            if (res) {
                const blob = new Blob([res.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;

                let fileName = "report.xlsx"; // fallback
                const contentDisposition = res.headers["content-disposition"];
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+?)"?$/);
                    if (match && match[1]) {
                        fileName = match[1];
                    }
                }

                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove(); // cleanup
                window.URL.revokeObjectURL(url); // cleanup
            }
            setTransactionLoading(false);
            return res.data;
        } catch (error) {
            setTransactionLoading(false);

            let _error = "Something went wrong.";

            if (error.message === "Network Error") {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    return (
        <AffiliateContext.Provider
            value={{
                affiliates,
                affiliate,
                totalElements,
                getSubscriptionPlanForAffiliate,
                pharmacySubscriptionPlan,
                loading,
                initProductLoading,
                initAffiliateFileLoading,
                getAffiliateById,
                errorMsg,
                getAllAffiliate,
                updateAffiliate,
                addAffiliate,
                changeAffiliatePasswordById,
                disableOrEnableAffiliate,
                generateAffiliateExcelReport,
                transactionLoading,
                getAllCommission,
                commissionList
            }}
        >
            {children}
        </AffiliateContext.Provider>
    );
}

export default AffiliateContextProvider;
